module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "storagelist"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberstorage'
      },
      "replace": ""
    }
  }, [_vm._v("会员储值")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("储值会员")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.storeData.data,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.avatar || scope.row.c_avatar) ? _c('img', {
          attrs: {
            "src": scope.row.avatar || scope.row.c_avatar,
            "alt": ""
          }
        }) : _c('img', {
          attrs: {
            "src": require("../../assets/img/default.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "label": "手机号",
      "prop": "mobile"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "label": "生日",
      "prop": "birthday"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "label": "本店储值次数",
      "prop": "recharge_times"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.balance)) + "元")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.goDetail(scope.row.c)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.storeData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.storeData.count,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5ea6df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/storagelist/storagelist.vue
// module id = 818
// module chunks = 1